import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPython, FaTerminal, FaLayerGroup, FaReact, FaRobot, FaPaperPlane, FaDatabase, FaSearch, FaJsSquare, FaLink } from "react-icons/fa";
import "../../Assets/OrbitalMenu.scss"; // Import the CSS for styles
import Profile from "../../Assets/Profile.png"
import Medal from "../../Assets/GoldMedal.jpg"
function OrbitalMenu() {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <div className="orbital-menu">
            <ul className="orbital-menu__list">
              <li className="orbital-menu__item ">
                <a href="#python" className="orbital-menu__link">
                  <span className="orbital-menu__link-icon "><FaPython /></span>
                  <span className="orbital-menu__link-text">Python</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#csharp" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon"><FaTerminal /></span>
                  <span className="orbital-menu__link-text">C#</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#dotnet" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon"><FaLayerGroup /></span>
                  <span className="orbital-menu__link-text">.NET</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#react" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon "><FaReact /></span>
                  <span className="orbital-menu__link-text">React</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#ai-ml" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon"><FaRobot /></span>
                  <span className="orbital-menu__link-text">AI & ML</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#sql" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon"><FaDatabase /></span>
                  <span className="orbital-menu__link-text">SQL</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#elastic-search" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon"><FaSearch /></span>
                  <span className="orbital-menu__link-text">Elastic Search</span>
                </a>
              </li>
              <li className="orbital-menu__item">
                <a href="#javascript" className="orbital-menu__link" >
                  <span className="orbital-menu__link-icon"><FaJsSquare /></span>
                  <span className="orbital-menu__link-text">JavaScript</span>
                </a>
              </li>
           
            </ul>

            <div className="orbital-menu__center-pic image-container">
              <img className="orbital-menu__center-pic-medal image-second"
                src={Medal}
                alt="GoldMedal"
              />
              <img className="orbital-menu__center-pic first-image"
                src={Profile}
                alt="Profile"
              />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default OrbitalMenu;
